import React from "react";
import UserManagement from "../Pages/DMS/UserManagement/UserManagement";
import CreateUser from "../Pages/DMS/UserManagement/CreateUser/CreateUser";
import ViewUser from "../Pages/DMS/UserManagement/ViewUser/ViewUser";
import ViewUserTask from "../Pages/DMS/UserTaskManagement/ViewUserTask/ViewUserTask";
import ResourceManagement from "../Pages/DMS/ResourceManagement/ResourceManagement";
import ResourceList from "../Pages/DMS/ResourceManagement/ResourceList/ResourceList";
import ViewResource from "../Pages/DMS/ResourceManagement/ViewResource/ViewResource";
import RegionManagement from "../Pages/DMS/RegionManagement/RegionManagement";
import RegionList from "../Pages/DMS/RegionManagement/RegionList/RegionList";
import CreateAgency from "../Pages/DMS/AgencyManagement/CreateAgency/CreateAgency";
import AgencyManagement from "../Pages/DMS/AgencyManagement/AgencyManagement";
import AgencyTable from "../Pages/DMS/AgencyManagement/AgencyTable/AgencyTable";
import ViewAgency from "../Pages/DMS/AgencyManagement/ViewAgency/ViewAgency";
import MasterDataManagement from "../Pages/DMS/MasterDataManagement/MasterDataManagement";
import CreateRegionForm from "../Pages/DMS/RegionManagement/CreateRegion/CreateRegion";
import ContactManagement from "../Pages/DMS/ContactManagement/ContactManagement";
import CreateContact from "../Pages/DMS/ContactManagement/CreateContact/CreateContact";
import ContactView from "../Pages/DMS/ContactManagement/ContactView/ContactView";
import ResourceManagementEntity from "../Pages/DMS/ResourceEntityManagement/ResourceManagementEntity";
import TaskManagement from "../Pages/DMS/TaskManagement/TaskManagement";
import CreateTask from "../Pages/DMS/TaskManagement/CreateTask/CreateTask";
import ViewTaskDetail from "../Pages/DMS/TaskManagement/ViewTaskDetail/ViewTaskDetail";
import CreateFacility from "../Pages/DMS/FacilityManagement/CreateFacility/CreateFacility";
import FacilityManagement from "../Pages/DMS/FacilityManagement/FacilityManagement";
import MyTaskListManagement from "../Pages/DMS/MyTaskListManagement/MyTaskListManagement";
import FacilityList from "../Pages/DMS/FacilityManagement/FacilityList/FacilityList";
import ViewFacility from "../Pages/DMS/FacilityManagement/ViewFacility/ViewFacility";
import MasterResourceManagement from "../Pages/DMS/MasterResourceManagement/MasterResourceManagement";
import CreateMasterResource from "../Pages/DMS/MasterResourceManagement/CreateMasterResource/CreateMasterResource";
import ViewMasterResource from "../Pages/DMS/MasterResourceManagement/ViewMasterResource/ViewMasterResource";
import CreateSOP from "../Pages/DMS/SOPManagement/CreateSOP/CreateSOP";
import SOPManagement from "../Pages/DMS/SOPManagement/SOPManagement";
import RoleManagement from "../Pages/DMS/RoleManagement/RoleManagement";
import CreateRole from "../Pages/DMS/RoleManagement/CreateRole/CreateRole";
import ViewRole from "../Pages/DMS/RoleManagement/ViewRole/ViewRole";
import ViewSOP from "../Pages/DMS/SOPManagement/ViewSOP/ViewSOP";
import GisManagement from "../Pages/DMS/GisManagement/GisManagement";
import ReportManagement from "../Pages/DMS/ReportManagement/FormBuilder";
import FormViewer from "../Pages/DMS/ReportManagement/FormViewer";
import FormRenderer from "../Pages/DMS/ReportManagement/FormRenderer";
import SOPExecutionManagement from "../Pages/DMS/GisManagement/SOPExecutionManagement";
import FormBuilder from "../Pages/DMS/ReportManagement/FormBuilder";
import CreateResource from "../Pages/DMS/ResourceManagement/CreateResource/CreateResource";
import IncidentManagement from "../Pages/DMS/GisManagement/IncidentManagement";
import EventManagement from "../Pages/DMS/GisManagement/EventManagement";
import ExecuteSOP from "../Pages/DMS/GisManagement/ExecuteSOP";
import DeploymentList from "../Pages/DMS/GisManagement/DeploymentList";
import DeployResource from "../Pages/DMS/GisManagement/DeployResource";
import UserTaskManagement from "../Pages/DMS/UserTaskManagement/UserTaskManagement";
import UserTaskForm from "../Pages/DMS/UserTaskManagement/UserTaskForm/UserTaskForm";
import AnimalShelter from "../Pages/DMS/Dashboard/AnimalShelter/AnimalShelter";
import CommunityKitchen from "../Pages/DMS/Dashboard/CommunityKitchen/CommunityKitchen";
import FloodReliefCamp from "../Pages/DMS/Dashboard/FloodReliefCamp/FloodReliefCamp";
import FloodReliefCenter from "../Pages/DMS/Dashboard/FloodReliefCenter/FloodReliefCenter";
import DistDashboard from "../Pages/DMS/Dashboard/StateDashboard/StateDashboard";
import DailyFloodReport from "../Pages/DMS/Dashboard/DailyFloodReport/DailyFloodReport";
import ViewDailyFloodReport from "../Pages/DMS/Dashboard/DailyFloodReport/ViewDailyFloodReport/ViewDailyFloodReport";
import DailyFloodReportComp from "../Pages/DMS/Dashboard/DailyFloodReportComp/DailyFloodReportComp";
import StateDashboard from "../Pages/DMS/Dashboard/StateDashboard/StateDashboard";
import DailyFloodReportEditableForm from "../Pages/DMS/Dashboard/DailyFloodReportEditableForm/DailyFloodReportEditableForm";
import StateFloodReport from "../Pages/DMS/Dashboard/StateFloodReport/StateFloodReport";
import Form9 from "../Pages/DMS/Dashboard/StateFloodReport/Form9/Form9";
import DailyFloodReportStatus from "../Pages/DMS/Dashboard/DailyFloodReportStatus/DailyFloodReportStatus";
import AffectedReport from "../Pages/DMS/Dashboard/AffectedReport/AffectedReport";
import PartiallyAffectedReport from "../Pages/DMS/Dashboard/PartiallyAffectedReport/PartiallyAffectedReport";
import MISDistFloodReport from "../Pages/DMS/Dashboard/MISDistFloodReport/MISDistFloodReport";
import MISStateFloodReport from "../Pages/DMS/Dashboard/MISStateFloodReport/MISStateFloodReport";
import DailyAffectedFloodReport from "../Pages/DMS/Dashboard/DailyAffectedFloodReport/DailyAffectedFloodReport";
import DailyPartiallyAffectedFloodReport from "../Pages/DMS/Dashboard/DailyPartiallyAffectedFloodReport/DailyPartiallyAffectedFloodReport";
import DMSDashboard from "../Pages/DMS/Dashboard/DMSDashboard/DMSDashboard";
import RTIncidentDashboard from "../Pages/DMS/GisManagement/RTIncidentDashboard";
import DailyColdWaveReport from "../Pages/DMS/Dashboard/DailyColdWaveReport/DailyColdWaveReport";
import DailyHeatWaveReport from "../Pages/DMS/Dashboard/DailyHeatWaveReport/DailyHeatWaveReport";
import MISDistHeatWaveReport from "../Pages/DMS/Dashboard/MISDistHeatWaveReport/MISDistHeatWaveReport";
import FireCommunityKitchenReport from "../Pages/DMS/Dashboard/FireCommunityKitchenReport/FireCommunityKitchenReport";
import FireIncidentReport from "../Pages/DMS/Dashboard/FireIncidentReport/FireIncidentReport";
import MISDistFireReport from "../Pages/DMS/Dashboard/MISDistFireReport/MISDistFireReport";
import DailyHeatWaveReportStatus from "../Pages/DMS/Dashboard/DailyHeatWaveReportStatus/DailyHeatWaveReportStatus";
import HumanLossdashboard from "../Pages/DMS/Dashboard/HumanLossDashboard/HumanLossDashboard";
import UserActivityManagement from "../Pages/DMS/UserManagement/UserActivity/UserActivityManagement";
import HumanLossReport from "../Pages/DMS/Dashboard/HumanLossReport/HumanLossReport";
import HumanLossForm from "../Pages/DMS/Dashboard/HumanLossDetails/HumanLossForm/HumanLossForm";
import ColdWaveDashboard from "../Pages/DMS/Dashboard/CodlWaveDashboard/ColdWaveDashboard";
import FireDashboard from "../Pages/DMS/Dashboard/FireDashboard/FireDashboard";
import DailyCloudBurstReport from "../Pages/DMS/Dashboard/DailyCloudBurstReport/DailyCloudBurstReport";
import HeatWaveDashboard from "../Pages/DMS/Dashboard/HeatWaveDashboard/HeatWaveDashboard";
import MISHeatWaveReportTable from "../Pages/DMS/Dashboard/MISDistCloudBurstReport/MISCloudBurstReportTable";
import MISDistCloudBurstReport from "../Pages/DMS/Dashboard/MISDistCloudBurstReport/MISDistCloudBurstReport";
import MISDistHumanLossReport from "../Pages/DMS/Dashboard/MISDistHumanLossReport/MISDistHumanLossReport";
import MISDistAvalancheReport from "../Pages/DMS/Dashboard/MISDistAvalancheReport/MISDistAvalancheReport";
import MISDistGlofReport from "../Pages/DMS/Dashboard/MISDistGlofReport/MISDistGlofReport";
import MISDistEarthquakeReport from "../Pages/DMS/Dashboard/MISDistEarthquakeReport/MISDistEarthquakeReport";
import MISDistColdWaveReport from "../Pages/DMS/Dashboard/MISDistColdWaveReport/MISDistColdWaveReport";
import DailyColdWaveReportStatus from "../Pages/DMS/Dashboard/DailyColdWaveReportStatus/DailyColdWaveReportStatus";
import DailyCloudBurstReportStatus from "../Pages/DMS/Dashboard/DailyCloudBurstReportStatus/DailyCloudBurstReportStatus";
import SopsInstance from "../Pages/DMS/SOPManagement/SopsInstance/SopsInstance";
import ExecuteSops from "../Pages/DMS/SOPManagement/ExecuteSops";
import SopInstance from "../Pages/DMS/SOPManagement/SopInstance/SopInstance";
import ViewSopInstance from "../Pages/DMS/SOPManagement/SopInstance/ViewSopInstance/ViewSopInstance";
import ViewedSopInstance from "../Pages/DMS/SOPManagement/ViewedSopInstance/ViewedSopInstance/ViewedSopInstance";
import IncidentCategoryMatrix from "../Pages/DMS/SOPManagement/IncidentCategoryMatrix/IncidentCategoryMatrix";
import IncidentManagementt from "../Pages/DMS/GisincidentManagement/IncidentManagementt";
import CreateIncident from "../Pages/DMS/Incidentmanagement/CreateIncident";
import CreateEvent from "../Pages/DMS/Incidentmanagement/CreateEvent";
import GisMapview from "../Pages/DMS/GisincidentManagement/GisMapview";
import DeploymentResource from "../Pages/DMS/ResponseRelief/DeploymentResource";
import ResourceAssignAndDeploy from "../Pages/DMS/ResponseRelief/ResourceAssignAndDeploy";
import Chatbot from "../Pages/DMS/Chatbot/Chatbot";
import GrievanceMainForm from "../Pages/DMS/RentalGrievance/GrievanceMainForm";
import GrievanceList from "../Pages/DMS/RentalGrievance/GrievanceList";
import GrievanceViewTickets from "../Pages/DMS/RentalGrievance/GrievanceViewTickets/GrievanceViewTickets";
import AccidentViewerHeader from "../Pages/DMS/DisasterNotification/AccidentViewerHeader";
import AccidentsHistory from "../Pages/DMS/DisasterNotification/AccidentsHistoryMain";
import ActivePanelHeader from "../Pages/DMS/ActivePanel/ActivePanelHeader";
import CloudburstDashboard from "../Pages/DMS/Dashboard/CloudBrust/CloudBrustDashboard";
import AvalancheDashboard from "../Pages/DMS/Dashboard/AvalancheDAshboard/AvalancheDashboard";
import GLOFDashboard from "../Pages/DMS/Dashboard/GolfDashboard/GlofDashboard";
import DailyAvalancheReportStatus from "../Pages/DMS/Dashboard/DailyAvalancheReportStatus/DailyAvalancheReportStatus";
import DailyGlofReportStatus from "../Pages/DMS/Dashboard/DailyGlofReportStatus/DailyGlofReportStatus";
import DailyEarthquakeReportStatus from "../Pages/DMS/Dashboard/DailyEarthquakeReportStatus/DailyEarthquakeReportStatus";
import DailyFireWaveReportStatus from "../Pages/DMS/Dashboard/DailyFireWaveReportStatus/DailyFireWaveReportStatus";
import DailyFireReportEditableForm from "../Pages/DMS/Dashboard/DailyFireReportEditableForm/DailyFireReportEditableForm";
import EarthquakeDashboard from "../Pages/DMS/Dashboard/EarthQuakeDashboard/EarthQuakeDashboard";
import DailyAvalancheReport from "../Pages/DMS/Dashboard/DailyAvalancheReport/DailyAvalancheReport";
import DailyGlofReport from "../Pages/DMS/Dashboard/DailyGlofReport/DailyGlofReport";
import DailyEarthquakeReport from "../Pages/DMS/Dashboard/DailyEarthquakeReport/DailyEarthquakeReport";
import GrievanceMain from "../Pages/DMS/HelpdeskOrGrievance/GrievanceMain";
import RaiseTicketMain from "../Pages/DMS/HelpdeskOrGrievance/RaiseTicketMain";
import ViewRiasedTicketMain from "../Pages/DMS/HelpdeskOrGrievance/ViewRiasedTicketMain";
import ManageSlaMain from "../Pages/DMS/HelpdeskOrGrievance/ManageSlaMain";
// import CreateHolidaysFormMain from "../Pages/DMS/Branches/CreateHolidysFormMain";
// import HolidaysListMain from "../Pages/DMS/Branches/HolidaysListMain";
import AuditHistoryMain from "../Pages/DMS/HelpdeskOrGrievance/AuditHistoryMain";
import DetailsAuditHistoryMain from "../Pages/DMS/HelpdeskOrGrievance/DetailsAuditHistoryMain";

// User Management Routes
export const lms_routes_regs = [
  { name: "create-user", component: <CreateUser /> },
  { name: "view-user", component: <ViewUser /> },
  { name: "users", component: <UserManagement /> },
  { name: "roles", component: <RoleManagement /> },
  { name: "create-role", component: <CreateRole /> },
  { name: "view-role", component: <ViewRole /> },
];

// Resource Management Routes
export const resource_routes_regs = [
  { name: "resource", component: <ResourceManagement /> },
  { name: "resource-list", component: <ResourceList /> },
  { name: "create-resource", component: <CreateResource /> },
  { name: "view-resource", component: <ViewResource /> },
];

// Master Resource Routes
export const masterresource_routes_regs = [
  { name: "master-resource", component: <MasterResourceManagement /> },
  { name: "create-masterresource", component: <CreateMasterResource /> },
  { name: "view-masterresource", component: <ViewMasterResource /> },
];

export const resource_entity_routes_regs = [
  { name: "create-resourceentity", component: <ResourceManagementEntity /> },
];

// Region Routes
export const region_routes_regs = [
  { name: "region", component: <RegionManagement /> },
  { name: "region-list", component: <RegionList /> },
  { name: "region-form", component: <CreateRegionForm /> },
];

// Agency Routes
export const agency_routes_regs = [
  { name: "agency", component: <AgencyManagement /> },
  { name: "agency-list", component: <AgencyTable /> },
  { name: "create-agency", component: <CreateAgency /> },
  { name: "view-agency", component: <ViewAgency /> },
];

// Planning Routes (Administration & Planning)
export const planning_routes_regs = [
  { name: "view-task", component: <TaskManagement /> },
  { name: "view-taskinfo", component: <ViewTaskDetail /> },
  { name: "Sop-instance-list", component: <SopInstance /> },
  { name: "view-sop-instance", component: <ViewSopInstance /> },
  { name: "execute-sops", component: <ExecuteSops /> },
  { name: "create-task", component: <CreateTask /> },
  { name: "view-contact", component: <ContactManagement /> },
  { name: "create-contact", component: <CreateContact /> },
  { name: "contact-view", component: <ContactView /> },
  { name: "view-sop", component: <SOPManagement /> },
  { name: "create-sop", component: <CreateSOP /> },
  { name: "view-sopinfo", component: <ViewSOP /> },
  { name: "sops-instance", component: <SopsInstance /> },
  { name: "viewsops-instance", component: <ViewedSopInstance /> },
];

// Master Data Management Routes
export const masterdatamgmnt_routes_regs = [
  { name: "masterdata-table", component: <MasterDataManagement /> },
  {
    name: "event-category",
    component: <MasterDataManagement configType={"EVNT_CAT"} />,
  },
  {
    name: "region-type",
    component: <MasterDataManagement configType={"REGION_TYP"} />,
  },
  {
    name: "resource-category",
    component: <MasterDataManagement configType={"RSRC_CAT"} />,
  },
  {
    name: "resource-kind",
    component: <MasterDataManagement configType={"RSRC_KND"} />,
  },
  {
    name: "agency-type",
    component: <MasterDataManagement configType={"AGNC_TYP"} />,
  },
  {
    name: "incident-type",
    component: <MasterDataManagement configType={"INCDNT_TYP"} />,
  },
  {
    name: "incident-status",
    component: <MasterDataManagement configType={"INCDNT_STAT"} />,
  },
  {
    name: "tasks-tatus",
    component: <MasterDataManagement configType={"TSK_STAT"} />,
  },
  {
    name: "facilities-type",
    component: <MasterDataManagement configType={"FCLTY_TYP"} />,
  },
];

// Facility Management Routes
export const facility_routes_regs = [
  { name: "facility-mgmt", component: <FacilityManagement /> },
  { name: "facility-list", component: <FacilityList /> },
  { name: "view-facility", component: <ViewFacility /> },
  { name: "create-facility", component: <CreateFacility /> },
];

// My Tasks Routes
export const my_tasks_regs = [
  { name: "my-tasks", component: <MyTaskListManagement /> },
  { name: "view-usertask", component: <UserTaskManagement /> },
  { name: "create-usertask", component: <UserTaskForm /> },
  { name: "usertask-view", component: <ViewUserTask /> },
];

// GIS Management Routes
export const my_gis_mgmnt_regs = [
  { name: "gismanagement", component: <GisManagement /> },
  { name: "map-view", component: <GisManagement /> },
  { name: "response-relief", component: <DeploymentList /> },
  { name: "event-mgmnt", component: <EventManagement /> },
  { name: "incident-mgmnt", component: <IncidentManagement /> },
];

// SOP Management Routes
export const my_sop_mgmnt_regs = [
  { name: "sopexecution", component: <SOPExecutionManagement /> },
  { name: "sop-instances", component: <SOPExecutionManagement /> },
  { name: "sop", component: <SOPExecutionManagement /> },
  { name: "execute-sop", component: <ExecuteSOP /> },
  { name: "resource-list", component: <DeploymentList /> },
  { name: "deploy-resource", component: <DeployResource /> },
];

// Report Management Routes
export const my_report_mgmnt_regs = [
  { name: "reportmanagement", component: <ReportManagement /> },
  { name: "create-form", component: <FormBuilder /> },
  { name: "user-activity", component: <UserActivityManagement /> },
];

// Form Viewers
export const form_viewers = [
  { name: "report-view", component: <FormViewer /> },
  { name: "create-form-view", component: <FormRenderer /> },
];

// Situational Awareness Routes
export const situal_awaren = [
  { name: "situation-awareness", component: <GisMapview /> },
  { name: "incident-management", component: <IncidentManagementt /> },
  { name: "create-incidentpage", component: <CreateIncident /> },
  { name: "create-event", component: <CreateEvent /> }
];

// Dashboard Routes
export const dmsdashboard = [
  { name: "dmsdashboard", component: <DMSDashboard /> },
  { name: "dist-dashboard", component: <StateDashboard /> },
  { name: "humanloss-dashboard", component: <HumanLossdashboard /> },
  { name: "Earthquake-dashboard", component: <EarthquakeDashboard /> },
  { name: "coldwave-dashboard", component: <ColdWaveDashboard /> },
  { name: "fire-dashboard", component: <FireDashboard /> },
  { name: "heatwave-dashboard", component: <HeatWaveDashboard /> },
  { name: "cloudbrust-dashboard", component: <CloudburstDashboard /> },
  { name: "Avalanche-dashboard", component: <AvalancheDashboard /> },
  { name: "Glof-dashboard", component: <GLOFDashboard /> },
  { name: "incidentdashboard", component: <RTIncidentDashboard /> },
];

// Disaster Acknowledgement Routes
export const disaster_ack = [
  { name: "alertview", component: <AccidentViewerHeader /> },
];

export const alert_disa = [
  { name: "alertdissater", component: <AccidentsHistory /> },
];

export const active_panel = [
  { name: "activepanel", component: <ActivePanelHeader /> },
];

// Pre Disaster & Early Warning child routes
export const pre_disaster_routes = [
  // SOP Management
  { name: "view-sop", component: <SOPManagement /> },
  { name: "view-task", component: <TaskManagement /> },
  { name: "category-matrix", component: <IncidentCategoryMatrix /> },
  { name: "create-sop", component: <CreateSOP /> },
  { name: "execute-sops", component: <ExecuteSops /> },
  { name: "Sop-instance-list", component: <SopInstance /> },
  { name: "view-sop-instance", component: <ViewSopInstance /> },
  { name: "create-task", component: <CreateTask /> },
  { name: "view-sopinfo", component: <ViewSOP /> },
  { name: "sops-instance", component: <SopsInstance /> },
  { name: "viewsops-instance", component: <ViewedSopInstance /> },

  // Response & Relief
  { name: "resource-assign-list", component: <ResourceAssignAndDeploy /> },
  { name: "deployment-resource", component: <DeploymentResource /> },

  // Task Management
  { name: "my-tasks", component: <MyTaskListManagement /> },
  { name: "view-usertask", component: <UserTaskManagement /> },
  { name: "create-usertask", component: <UserTaskForm /> },
  { name: "usertask-view", component: <ViewUserTask /> },

  // Resource Activity Panel
  { name: "Active-panellist", component: <ActivePanelHeader /> },
];

// Reports Routes
export const reportsMap = [
  { name: "animal-shelter", component: <AnimalShelter /> },
  { name: "community-kitchen", component: <CommunityKitchen /> },
  { name: "fl-center", component: <FloodReliefCenter /> },
  { name: "daily-flood-report", component: <DailyFloodReport /> },
  { name: "view-daily-flood-report", component: <ViewDailyFloodReport /> },
  { name: "fl-camp", component: <FloodReliefCamp /> },
  { name: "dailyfloodreport", component: <DailyFloodReportComp /> },
  { name: "affected-floodreport", component: <DailyAffectedFloodReport /> },
  { name: "partiallyaffected-floodreport", component: <DailyPartiallyAffectedFloodReport /> },
  { name: "reporting-status", component: <DailyFloodReportStatus /> },
  { name: "cold-wave-reporting-status", component: <DailyColdWaveReportStatus /> },
  { name: "heat-wave-reporting-status", component: <DailyHeatWaveReportStatus /> },
  { name: "fire-wave-reporting-status", component: <DailyFireWaveReportStatus /> },
  { name: "cloud-burst-reporting-status", component: <DailyCloudBurstReportStatus /> },
  { name: "avalanche-wave-reporting-status", component: <DailyAvalancheReportStatus /> },
  { name: "glof-reporting-status", component: <DailyGlofReportStatus /> },
  { name: "earthquake-reporting-status", component: <DailyEarthquakeReportStatus /> },
  { name: "misdist-report", component: <MISDistFloodReport /> },
  { name: "misstate-report", component: <MISStateFloodReport /> },
  {
    name: "editdfr",
    component: <DailyFloodReportEditableForm />,
  },
  {
    name: "fire-editdfr",
    component: <DailyFireReportEditableForm />,
  },
  { name: "statefloodreport", component: <StateFloodReport /> },
  { name: "form9", component: <Form9 /> },
  { name: "affected-report", component: <AffectedReport /> },
  { name: "partiallyaffected-report", component: <PartiallyAffectedReport /> },
  { name: "fire-community-kitchen-report", component: <FireCommunityKitchenReport /> },
  { name: "dr-cold-wave", component: <DailyColdWaveReport /> },
  { name: "cloud-burst-report", component: <DailyCloudBurstReport /> },
  { name: "cloud-burst-misreport", component: <MISDistCloudBurstReport /> },
  { name: "heat-wave-report", component: <DailyHeatWaveReport /> },
  { name: "heat-wave-misreport", component: <MISDistHeatWaveReport /> },
  { name: "human-loss-report", component: <HumanLossReport /> },
  { name: "human-loss-form", component: <HumanLossForm /> },
  { name: "fireincident-report", component: <FireIncidentReport /> },
  { name: "avalancheincident-report", component: <DailyAvalancheReport /> },
  { name: "glofincident-report", component: <DailyGlofReport /> },
  { name: "earthquakeincident-report", component: <DailyEarthquakeReport /> },
  { name: "mis-human-loss-report", component: <MISDistHumanLossReport /> },
  { name: "mis-avalanche-report", component: <MISDistAvalancheReport /> },
  { name: "mis-glof-report", component: <MISDistGlofReport /> },
  { name: "mis-earthquake-report", component: <MISDistEarthquakeReport /> },
  { name: "mis-fire-report", component: <MISDistFireReport /> },
  { name: "misdist-coldwave-report", component: <MISDistColdWaveReport /> },
];

// Resource Allocation Routes
export const resourceallocation_routes_regs = [
  { name: "resource-assign-list", component: <ResourceAssignAndDeploy /> },
  { name: "deployment-resource", component: <DeploymentResource /> },
];

// Housing Grievance Routes
export const housing_grievance = [
  { name: "grievance-rental", component: <GrievanceMainForm /> },
  { name: "grievance-rental-tickets", component: <GrievanceList /> },
  { name: "grievance-rental-view-tickets", component: <GrievanceViewTickets /> },
];
export const grievance_routes = [
  { name: "grievance", component: <GrievanceMain /> },
  { name: "raise-ticket", component: <RaiseTicketMain /> },
  { name: "view-raise-ticket", component: <ViewRiasedTicketMain /> },
  { name: "manage-sla", component: <ManageSlaMain /> },
  { name: "audit-history", component: <AuditHistoryMain /> },
  { name: "details-audit-history", component: <DetailsAuditHistoryMain /> },
];